import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Modal from './RespModal';
import cross from '../../Assets/ContainerStatus/Assets_Desktop/close-icon.svg';
import alertIcon from '../../Assets/ContainerStatus/Assets_Desktop/alert.svg';
import Button from '../Shared/Button';
import '../../css/Shared/ManageSubscriptionModal.css';

class ManageProfileModal extends React.Component {
    render() {
        return(
            <Modal hasOpen={this.props.hasOpen}>
                <div className="manageSubscriptionouterModal">
                    <div className='modalcross'>
                        <img src={cross} onClick={this.props.onCloseModal} width="30" height="30" class="d-inline-block align-top" alt="" loading="lazy" />
                    </div>
                    <div>
                        <img alt="alert" src={alertIcon} width="70" height="70" class="d-inline-block align-top" alt="" loading="lazy" />
                    </div>
                    <div>
                      {this.props.children}
                    </div>
                    <Button
                        type="button"
                        className='modalbtn'
                        onClick={this.props.onClickModal}
                        id="buttonmodal"
                    >OK
                    </Button><br /><br />
                </div>
            </Modal>
        );
    }
}
export default ManageProfileModal;